import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Retry = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M3.972 14.667A8 8 0 1 0 11.517 4C8.633 4 6.759 5.301 4.899 7.5M4.489 4v3.25c0 .414.335.75.75.75h3.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.488 3a1 1 0 0 1 1 1v1.424C7.111 3.922 8.965 3 11.517 3a9 9 0 1 1 0 18 9 9 0 0 1-8.488-6 1 1 0 0 1 1.886-.667A7 7 0 1 0 11.517 5c-1.974 0-3.403.68-4.787 2h1.758a1 1 0 1 1 0 2h-3.25a1.75 1.75 0 0 1-1.75-1.75V4a1 1 0 0 1 1-1'
        fill='currentColor'
      />
    )}
  </IconBase>
);
